import { SUPER_ADMIN_ROLE } from "@lib/constants/advisor";
import { useAppStore } from "@/store/app";
import { storeToRefs } from "pinia";

export default defineNuxtPlugin(async () => {
  const $route = useRoute();
  if ($route.fullPath.startsWith("/client")) {
    return {
      provide: {
        isSuperAdmin: computed(() => false),
      },
    };
  }
  const { user } = storeToRefs(useAppStore());
  if (!user.value) {
    useNuxtApp().$fetchUserDebounced?.();
  }

  return {
    provide: {
      isSuperAdmin: computed(() => user.value?.user_type === SUPER_ADMIN_ROLE),
    },
  };
});
